import styled from 'styled-components';

export const StyledMeetingVideoResizableRect = styled.div.attrs(props => ({
  className: props.className
}))`
/* Code Here */
`;